export enum WorkspaceTypes {
  affiliate = "affiliate",
  site = "site",
  delivery = "delivery",
  billing = "billing",
  carrier = "carrier",
  pumper = "pumper",
  region = "region",
}
